export default "__VITE_ASSET__DiQnWZOi__"